<template>
  <div class="features" :class="modifiers">
    <div class="features__items">
      <div
        v-for="(item, i) in items"
        :key="`item_${i}`"
        class="features__item"
        data-animation="fadeInBottom"
        :data-animation-delay="delay + (i * itemDelay)"
      >
        <BasePoster
          v-if="item.image"
          :name="item.image"
          :is-round="isClean"
          class="features__image"
        />
<!--         <BaseVideo
          v-if="item.video"
          :file="`${item.video}.mp4`"
          :autoplay="10"
          :controls="false"
          muted="muted"
          is-loop
          :is-round="isClean"
          class="features__image"
        /> -->
        <div class="features__content">
          <BaseTitle v-if="item.title" :text="item.title" size="l" is-medium class="features__title" />
          <BaseList v-if="item.list" :items="item.list" class="features__list" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePoster from '@/components/BasePoster.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseList from '@/components/BaseList.vue';
// import BaseVideo from '@/components/BaseVideo.vue';

export default {
  name: 'BaseFeatures',
  components: {
    BasePoster,
    BaseTitle,
    BaseList,
    // BaseVideo,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isClean: {
      type: Boolean,
      default: false,
    },
    isDouble: {
      type: Boolean,
      default: false,
    },
    isTriple: {
      type: Boolean,
      default: false,
    },
    itemDelay: {
      type: Number,
      default: 300,
    },
    delay: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    modifiers() {
      return {
        features_triple: this.isTriple,
        features_double: this.isDouble,
        features_block: !this.isClean,
      };
    },
  },
};
</script>

<style lang="stylus">
.features
  display block

  &__items
    ~/_double &
    ~/_triple &
      +landscape()
        display flex
        flex-wrap wrap
        justify-content space-between

  &__item
    margin-top 3em
    ~/_block &
      margin-top 2em
    &:first-child
      margin-top 0
    ~/_block &
      box-shadow 0 4px 25px rgba(7, 68, 87, 0.15)
      border-radius 1em
      overflow hidden

    ~/_double &
      +landscape()
        flex 0 0 50%
        max-width calc(50% - 1em)
        margin 0
        &:not(:nth-child(-n+2))
          margin-top 3em

    ~/_triple &
      +landscape()
        flex 0 0 33.33333333%
        max-width calc(33.33333333% - 0.7em)
        margin 0
        &:not(:nth-child(-n+3))
          margin-top 3em

  &__image
    margin-bottom 1.2em
    ~/_block &
      margin-bottom 0

  &__content
    ~/_block &
      padding 1.4em
      background-color #f9f9f9

  &__title
    color #29464F
    margin-bottom 0.5em
    +landscape()
      font-size 1.25em

  &__list
    +landscape()
      font-size 0.9em
</style>
